<template>
    <div class="cookie-banner" v-if="!isSelected">
        <p class="title">We value your privacy</p>
        <div class="row">
            <div class="col-md-9">
                <p>
                    This website uses cookies to enhance your browsing experience and provide personalized content. By clicking "Accept All", you consent to our use of cookies. To learn more, visit our
                    <a
                        href="/cookie-policy"
                        class="link"
                        >Cookie Policy</a
                    >
                </p>
            </div>
            <div class="col-md-3">
                <div class="buttons-section">
                    <button
                        class="btn btn-opt-out"
                        @click="isCustomize = !isCustomize"
                    >
                        Customize
                    </button>
                    <button class="btn btn-opt-out" @click="onSelectAll(false)">
                        Reject All
                    </button>
                    <button class="btn btn-opt-in" @click="onSelectAll(true)">
                        Accept All
                    </button>
                </div>
            </div>
        </div>
        <div class="customize-section" v-show="isCustomize">
            <p class="title">Manage Preferences</p>
            <p>
                We use cookies to collect information about you and your activity across the Site. You have the option to enable or disable specific cookie categories. Disabling some cookies may impact your browsing experience.
            </p>
            <p>
                Below you can read about each cookie category and selectively enable or disable cookies in each category. When previously allowed categories are disabled, cookies assigned to those categories will be removed from your browser.
            </p>
            <div
                class="customize-list"
                v-for="(cookie, index) in cookieList"
                :key="index"
            >
                <div class="row">
                    <div class="col-md-4">
                        <p
                            class="subtitle"
                            @click="cookie.isExpand = !cookie.isExpand"
                        >
                            <i
                                :class="
                                    `fa ${
                                        cookie.isExpand
                                            ? 'fa-chevron-up'
                                            : 'fa-chevron-down'
                                    }`
                                "
                                aria-hidden="true"
                            ></i>
                            {{ cookie.name }}
                        </p>
                    </div>
                    <div class="col-md-8 text-right">
                        <p
                            class="always-active-text"
                            v-if="cookie.isAlwaysActive"
                        >
                            Always Active
                        </p>
                        <div v-else>
                            <label class="switch">
                                <input
                                    type="checkbox"
                                    :checked="cookie.isActive"
                                    @change="
                                        cookieList[
                                            index
                                        ].isActive = !cookie.isActive
                                    "
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div v-show="cookie.isExpand">
                    <p>
                        {{ cookie.description }}
                    </p>
                    <div
                        class="customize-points"
                        v-for="(list, listIndex) in cookie.list"
                        :key="listIndex"
                    >
                        <div class="row">
                            <div class="col-md-2">
                                <strong>Cookie</strong>
                            </div>
                            <div class="col-md-10">
                                <p>{{ list.cookie }}</p>
                            </div>
                            <div class="col-md-2">
                                <strong>Duration</strong>
                            </div>
                            <div class="col-md-10">
                                <p>{{ list.duration }}</p>
                            </div>
                            <div class="col-md-2">
                                <strong>Description</strong>
                            </div>
                            <div class="col-md-10">
                                <p>{{ list.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="preferences-btn-section" v-show="isCustomize">
            <button class="btn btn-opt-in" @click="onSavePreferences">
                Save My Preferences
            </button>
        </div>
    </div>
    <div v-else class="floating-cookie" @click="handleFloatingButton">
        <img src="/img/icons/ic-cookie.svg" alt="cookie-img" srcset="" />
    </div>
</template>

<script>
export default {
    name: "CookieConsent",
    data() {
        return {
            isSelected: true,
            isCustomize: false,
            cookieList: [
                {
                    name: "Necessary",
                    description:
                        "Necessary cookies are essential for the proper functioning of our website. They enable basic features such as page navigation and adjusting the consent preferences. These cookies do not collect or store any personal information.",
                    isExpand: false,
                    isAlwaysActive: true,
                    isActive: true,
                    list: [
                        {
                            cookie: "asifa-cookies",
                            duration: "1 year",
                            description: "This cookie is set to remember users' consent preferences so that their preferences are respected on subsequent visits to this site. It does not gather or retain any personal information about the site visitors."
                        },
                        {
                            cookie: "annies",
                            duration: "Session",
                            description: "Session for My Annie Award website"
                        },
                        {
                            cookie: "auth_login",
                            duration: "1 month",
                            description: "Keep the session token of ASIFA Hollywood websites"
                        },
                    ]
                },
                {
                    name: "Functional",
                    description:
                        "Functional cookies are used to determine if the user's browser supports cookies.",
                    isExpand: false,
                    isAlwaysActive: false,
                    isActive: false,
                    list: [
                        {
                            cookie: "testcookie",
                            duration: "Session",
                            description: "Filestack sets this cookie to determine if the user's browser supports cookies."
                        }
                    ]
                },
                {
                    name: "Analytics",
                    description:
                        "Analytics cookies are used to analyze and understand how visitors interact with the website. The information is anonymized and helps us improve the performance and content of the site.",
                    isExpand: false,
                    isAlwaysActive: false,
                    isActive: false,
                    list: [
                        {
                            cookie: "_ga_*",
                            duration: "1 year 1 month 4 days",
                            description: "Google Analytics sets this cookie to store and count page views."
                        },
                        {
                            cookie: "_ga",
                            duration: "1 year 1 month 4 days",
                            description: "Google Analytics sets this cookie to calculate visitor, session and campaign data and track site usage for the site's analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognize unique visitors."
                        },
                        {
                            cookie: "_gcl_au",
                            duration: "90 days",
                            description: "This cookie is used by Google Analytics to understand user interaction with the website."
                        },
                        {
                            cookie: "_gid",
                            duration: "1 day",
                            description: "The cookie is used to store information of how visitors use a website and helps in creating an analytics report of how the website is doing. The data collected including the number visitors, the source where they have come from, and the pages visited in an anonymous form."
                        },
                        {
                            cookie: "_gat_gtag_UA_*",
                            duration: "1 minute",
                            description: "Google Analytics sets this cookie to store a unique user ID."
                        },
                    ]
                }
            ]
        };
    },
    mounted() {
        const userCookie = this.$cookies.get("ASIFA-COOKIES");

        if (!userCookie) {
            this.isSelected = false;
            fetch("https://ipapi.co/json/")
                .then(res => res.json())
                .then((data) => {
                    if (data.country_code == "US") {
                        this.cookieList = this.cookieList.map(list => {
                            list.isActive = true;
                            return list;
                        });
                    } else {
                        this.$cookies.set(
                            "ASIFA-COOKIES",
                            {
                                functional: false,
                                analytic: false
                            },
                            {
                                path: "/"
                            }
                        );
                    }
                })
            return;
        }

        this.cookieList[1].isActive = userCookie.functional;
        this.cookieList[2].isActive = userCookie.analytic;
        this.removeUnusedCookies()
    },
    updated() {
        this.removeUnusedCookies()
    },
    methods: {
        removeUnusedCookies () {
            setTimeout(() => {
                const cookies = this.$cookies.keys()
                this.cookieList.filter(cookie => !cookie.isActive).forEach(cookie => {
                const list = cookie.list.map(_cookie => _cookie.cookie).join('|')
                cookies.forEach((str) => {
                    if (new RegExp(list).test(str)) document.cookie = `${str}=; domain=.asifa-hollywood.org; expires= Thu, 01 Jan 1970 00:00:01 GMT;`
                })
                })
            }, 500)
        },
        onSelectAll(isTrue = true) {
            this.$cookies.set(
                "ASIFA-COOKIES",
                {
                    functional: isTrue,
                    analytic: isTrue
                },
                {
                    path: "/"
                }
            );
            this.isSelected = true;

            this.cookieList[1].isActive = isTrue;
            this.cookieList[2].isActive = isTrue;
        },
        onSavePreferences() {
            this.$cookies.set(
                "ASIFA-COOKIES",
                {
                    functional: this.cookieList[1].isActive,
                    analytic: this.cookieList[2].isActive
                },
                {
                    path: "/"
                }
            );
            this.isSelected = true;
        },
        handleFloatingButton() {
            this.isSelected = false;
            this.isCustomize = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 16px 24px;
  background: #16181e;
  font-family: "Open Sans";
  z-index: 10000;

  p {
    color: #ffffff;
    font-size: 14px;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
  }

  .subtitle {
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: #ffffff;
  }

  .link {
    color: #edaf01;
    font-weight: 500;
  }

  .buttons-section {
    display: flex;
    justify-content: end;

    .btn-opt-out {
      width: 240px;
      background-color: #edaf01;
      margin-right: 16px;
      color: #ffffff;

      &:hover {
        background: #d9a100;
        color: #ffffff;
      }
    }
  }
}
.btn-opt-in {
  width: 240px;
  background-color: #ffffff;
  font-weight: 500;
  color: #edaf01;
  border-color: #edaf01;

  &:hover {
    background: #d9a100;
    color: #ffffff;
  }
}

.customize-section {
  height: 300px;
  overflow-y: scroll;
  border-top: 1px solid #ffffff;
  margin-top: 16px;
  padding: 16px 0;

  strong {
    color: #ffffff;
    font-size: 14px;
  }

  .customize-list {
    border-top: 1px solid #ffffff;
    padding: 16px 16px;
    margin-top: 16px;

    .always-active-text {
      color: #edaf01;
      font-weight: 700;
      margin-left: auto;
    }

    .customize-points {
      padding: 16px;
      border-radius: 8px;
      background-color: rgba($color: #e3e3e3, $alpha: 0.3);
      margin-bottom: 8px;
    }

    .switch {
      display: flex;
      margin-left: auto;
    }
  }
}

.preferences-btn-section {
  display: flex;
  justify-content: end;
  padding: 16px 16px 0;
}

.floating-cookie {
  position: fixed;
  bottom: 16px;
  left: 16px;
  cursor: pointer;
  z-index: 1;

  img {
    width: 48px;
  }
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 26px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/CookieConsent.vue